import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import * as _ from 'lodash';
import 'rxjs/add/operator/map';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class CategoriaService extends TokenCommonService {

  catDeFantasia: any[] = [];
  arbolCompleto: any[] = [];
  padres: any[] = [];
  categoria: any;
  productos: any[] = [];
  totalMarcas: any[] = [];
  categoriaWasLoaded: Observable<any>;
  private categoriaWasLoadedSubject: Subject<any>;

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
    this.categoriaWasLoadedSubject = new Subject<any>();
    this.categoriaWasLoaded = this.categoriaWasLoadedSubject.asObservable();
  }

  get (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${ id }`)
      .map(res => {
        this.categoria = res.json().data;
        this.categoriaWasLoadedSubject.next(this.categoria);
        return this.categoria;
      });
  }

  getDeFantasia (params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }

    return this.http.get(`${ environment.API_URL }categorias/deFantasia`, options)
      .map(res => {
        this.catDeFantasia = res.json().data;
        return this.catDeFantasia;
      });
  }

  getTodasDeFantasia () {
    return this.tokenGet(`${ environment.API_URL }categorias/todasDeFantasia`);
  }

  getHijasDeFantasia (parentId: number, params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }

    return this.http.get(`${ environment.API_URL }categorias/${ parentId }/hijasDeFantasia`, options)
      .map(res => {
        this.catDeFantasia = res.json().data;
        return this.catDeFantasia;
      });
  }

  getArbolCompleto () {
    return this.http.get(`${ environment.API_URL }categorias/arbolGenealogico`)
      .map(res => {
        this.arbolCompleto = res.json().data;
        return this.arbolCompleto;
      });
  }

  getPadres () {
    return this.http.get(`${ environment.API_URL }categorias/padres`)
      .map(res => {
        this.padres = res.json().data;
        return this.padres;
      });
  }

  getHijas (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${id}/hijas`)
      .map(res => {
        this.padres = res.json().data;
        return this.padres;
      });
  }

  getPadresTodas () {
    return this.http.get(`${ environment.API_URL }categorias/padresTodas`)
      .map(res => {
        this.padres = res.json().data;
        return this.padres;
      });
  }

  getHijasTodas (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${id}/hijasTodas`)
      .map(res => {
        this.padres = res.json().data;
        return this.padres;
      });
  }

  getPadresEHijas () {
    return this.http.get(`${ environment.API_URL }categorias/padresEHijas`)
      .map(res => {
        return res.json().data;
      });
  }

  getProductos (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${ id }/productos`)
      .map(res => {
        return res.json().data;
      });
  }

  getTotalProductos (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${ id }/productos/total`)
      .map(res => {
        this.productos = res.json().data;
        return this.productos;
      });
  }

  getProductosPivote (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${ id }/productos/pivot`)
      .map(res => {
        this.productos = res.json().data;
        return this.productos;
      });
  }

  getTotalMarcas (id: number) {
    return this.http.get(`${ environment.API_URL }categorias/${ id }/marcas`)
      .map(res => {
        this.totalMarcas = res.json().data;
        return this.totalMarcas;
      });
  }

  getArchivos (id: number, params?: any) {
    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }

    return this.http.get(`${ environment.API_URL }categorias/${ id }/archivos`, options)
      .map(res => {
        return res.json().data;
      });
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }categorias/${id}`, data);
  }

  create(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }categorias`, data);
  }

  delete(id: number) {
    return this.tokenDelete(`${ environment.API_URL }categorias/${id}`);
  }

  setArchivo(id: number, archivo: FormData) {
    return this.tokenPost(`${ environment.API_URL }categorias/${ id }/archivos`, archivo);
  }

  editArchivo(idCategoria: number, idArchivo: number, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }categorias/${ idCategoria }/archivos/${ idArchivo }`, data);
  }

  deletaArchivo(idCategoria: number, idArchivo: number) {
    return this.tokenDelete(`${ environment.API_URL }categorias/${ idCategoria }/archivos/${ idArchivo }`);
  }

  setProducto(id: number, data: FormData) {
    return this.tokenPost(`${ environment.API_URL }categorias/${ id }/productos`, data);
  }

  deleteProducto(idCategoria: number, idProducto: number) {
    return this.tokenDelete(`${ environment.API_URL }productos/${ idProducto }/categorias/${ idCategoria }`);
  }

  gatAllProducts(id: number, params?: any) {
    return this.tokenGet(`${ environment.API_URL }categorias/${id}/productos/todos`, params);
  }

  changeOrderProducts(id: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }categorias/${id}/productos/cambiarOrden`, data);
  }

  changeOrderFantasyCategories(data: any) {
    return this.tokenPost(`${ environment.API_URL }categorias/cambiarOrden`, data);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/categoria/categoria.service.ts